import axios from 'axios';
import { API, API_URL } from '../constants';
import { getAllIndustryCategoriesAction } from '../store/industryCategories/actions';
import { getLocalStorageByKey } from '../utils/localStorage';

export const getIndustryCategories = () => {
  return async dispatch => {
    return await axios({
      method: 'GET',
      url: API_URL + API.GET.INDUSTRY_CATEGORY.GET,
      headers: { Authorization: 'Bearer ' + getLocalStorageByKey('token') },
    })
      .then(response => {
        const { data, status } = response;
        dispatch(getAllIndustryCategoriesAction(data));
        return { data, status };
      })
      .catch(error => {
        const { status } = error.response;
        return { data: {}, status };
      });
  };
};
